export enum FootballPosition {
    GK = "GK",     // Goalkeeper
    LB = "LB",     // Left Back
    CB = "CB",     // Centre Back
    RB = "RB",     // Right Back
    LWB = "LWB",   // Left Wing Back
    RWB = "RWB",   // Right Wing Back
    DM = "DM",     // Defensive Midfielder
    CM = "CM",     // Centre Midfielder
    AM = "AM",     // Attacking Midfielder
    LW = "LW",     // Left Winger
    RW = "RW",     // Right Winger
    S = "S",       // Striker
    CF = "CF",     // Centre Forward
}
